import * as React from "react";
import * as _ from "underscore";
import { Button } from "carbon-components-react";

import AdditionalIncomeForBorrower from "./AdditionalIncomeForBorrower";
import NewOtherIncomeForm from "./NewOtherIncomeForm";
import RentalIncome from "./RentalIncome";

const { Panel } = require("react-bootstrap");

interface IOtherIncomePanelProps {
  additionalIncomes: any;
  setDocId: Function;
  allDocs: any;
  ownedRealEstate: any;
  setOwnedRealEstateScheduleEPropertyLabel: Function;
  propertyLabelAndAddressOptions: Function;
  propertyLabelAndAddressOptionSelected: Function;
  handleChange: Function;
  loanApplicationID: Number;
  hasCoborrower: boolean;
}

interface IState {
  addingIncome: boolean;
}

class OtherIncomePanel extends React.Component<IOtherIncomePanelProps, IState> {
  state = {
    addingIncome: false,
  };

  toggleNewIncomeForm = () => {
    this.setState(prevState => ({ addingIncome: !prevState.addingIncome }));
  };

  documentsForOwner(ownerType, ownerID) {
    const docs = this.props.allDocs;
    return _.filter(
      docs,
      (document: any) =>
        document.owner_entity_type === ownerType && document.owner_entity_id === ownerID,
    );
  }

  taxReturns() {
    const { allDocs } = this.props;
    return allDocs.filter(document => document.type.startsWith("income_tax_return_"));
  }

  originalIncomeIndex = incomeID => _.findIndex(this.props.additionalIncomes, { id: incomeID });

  handleAdditionalIncomeChange(incomeID, field, value) {
    const originalIncomeIndex = this.originalIncomeIndex(incomeID);
    this.props.handleChange("additionalIncomes", originalIncomeIndex, field, value);
  }

  render() {
    const additionalIncomesByBorrower = _.chain(this.props.additionalIncomes)
      .sortBy("borrower_entity")
      .groupBy("borrower_entity")
      .mapObject((additionalIncomes, key) => (
        <AdditionalIncomeForBorrower
          key={key}
          additionalIncomes={additionalIncomes}
          header={`Borrower ${key} - Disclosed Additional Income`}
          setDocId={this.props.setDocId}
          incomeDocs={this.documentsForOwner.bind(this, "additional_income")}
          handleChange={this.handleAdditionalIncomeChange.bind(this)}
          hasCoborrower={this.props.hasCoborrower}
        />
      ))
      .values()
      .value();

    return (
      <Panel bsStyle="primary" defaultExpanded>
        <Panel.Heading>
          <Panel.Title toggle>Other Income</Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {additionalIncomesByBorrower}
            {this.state.addingIncome ? (
              <NewOtherIncomeForm
                loanApplicationID={this.props.loanApplicationID}
                onCancel={this.toggleNewIncomeForm}
                hasCoborrower={this.props.hasCoborrower}
              />
            ) : (
              <Button onClick={this.toggleNewIncomeForm}>Add Income</Button>
            )}
            {this.props.ownedRealEstate.length > 0 && (
              <RentalIncome
                propertyLabelAndAddressOptions={this.props.propertyLabelAndAddressOptions}
                propertyLabelAndAddressOptionSelected={
                  this.props.propertyLabelAndAddressOptionSelected
                }
                rentalProperties={this.props.ownedRealEstate}
                setOwnedRealEstateScheduleEPropertyLabel={
                  this.props.setOwnedRealEstateScheduleEPropertyLabel
                }
                setDocId={this.props.setDocId}
                getDocsForOwner={this.documentsForOwner.bind(this, "owned_real_estate")}
                taxReturns={this.taxReturns()}
                handleChange={this.props.handleChange.bind(this, "ownedRealEstate")}
              />
            )}
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    );
  }
}

export default OtherIncomePanel;
